import InfoRoundedIcon from "@mui/icons-material/InfoRounded";

export const info = (props) => {
  return <InfoRoundedIcon {...props} />;
};
